<router-outlet></router-outlet>

<p-toast key="sdohToastMessage" position="bottom-left"></p-toast>

<p-confirmDialog
  #cd
  header="Confirmation"
  appendTo="body"
  acceptLabel="Yes"
  rejectLabel="No"
  class="referral-dashboard-modal"
/>
